import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { BUTTON_SMALL_TYPES } from '../../constants'

import ButtonSmall from '../ButtonSmall/ButtonSmall'

import styles from './ButtonInbox.css'

class ButtonInbox extends React.PureComponent {
    static propTypes = {
        messages: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        onClick: PropTypes.func.isRequired,
        tooltipId: PropTypes.string,
        tabIndex: PropTypes.number,
        type: PropTypes.oneOf(BUTTON_SMALL_TYPES),
    }

    static defaultProps = { type: 'mini' }

    render() {
        const classNameBase = classNames(styles.base, {
            [styles['base__new-message']]: this.props.messages,
        })

        const messages = this.props.messages ? (
            <div className={styles.messages}>{this.props.messages}</div>
        ) : null

        const tabIndexAttr = this.props.tabIndex !== undefined ? {
            tabIndex: this.props.tabIndex,
        } : {}

        return (
            <div className={classNameBase}>
                <ButtonSmall
                    type={this.props.type}
                    onClick={this.props.onClick}
                    tooltipId={this.props.tooltipId}
                    {...tabIndexAttr}
                >
                    <div className={styles.icon} />
                </ButtonSmall>
                {messages}
            </div>
        )
    }
}

export default ButtonInbox



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/ButtonInbox/ButtonInbox.jsx